// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-container {
    margin-top: 2vh;
}

.col {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 20rem;
    width: -moz-fit-content;
    width: fit-content;
    height: -moz-fit-content;
    height: fit-content;
    border: 2px solid #70d4e9;
    background-color: #cdebf198;
    border-radius: 1rem;
    margin: .2rem .5rem;
    padding: .5rem 0;
}

.view {
    min-height: -moz-fit-content;
    min-height: fit-content;
}

.title-row .col {
    border: none;
    height: -moz-fit-content;
    height: fit-content;
    margin-bottom: .5rem;
    background-color: transparent;
}

.short {
    height: -moz-fit-content;
    height: fit-content;
}

.header {
    text-align: center;
    color: #000;
    /* margin-top: .5rem;
    margin-bottom: .3rem; */
    padding: .5rem 0;
    width: 100%;
    border-bottom: 2px solid #70d4e9;
}

.btn-row {
    margin: .5rem 0;
    width: 100%;
    height: 3.5rem;
}

.btn-row .col {
    border: none;
}

.col-22 {
    height: -moz-fit-content;
    height: fit-content;
    background: none;
}

.col-22 button {
    width: 20%;
    color: white;
    font-size: 1.2rem;
}

.input-group {
    height: 2.3rem;
    margin-top: .7rem;
}

.manual-form {
    display: flex;
    justify-content: start;
    flex-wrap: nowrap;
    width: 100%;
}

.manual-btn {
    width: 100%;
}

.form .form-control {
    background-color: white;
    color: black;
    font-size: 1.1rem;
    text-align: center;
}

.ml-module {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    height: -moz-fit-content;
    height: fit-content;
}

.ml-module .form-check {
    margin: .5rem 0;
    font-size: 1.2rem;
}

.form-check-label {
    padding: 0 1rem;
    font-size: 1.3rem;
    color: #161616;
}

/* Schema Link flow: only the modal should be visible, on a plain white page */
body.schemalink-mode {
    background-color: #ffffff;
}

body.schemalink-mode .modal-backdrop.show {
    background-color: #ffffff;
    opacity: 1;
}
`, "",{"version":3,"sources":["webpack://./src/style/HomePage.css"],"names":[],"mappings":"AAAA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAkB;IAAlB,kBAAkB;IAClB,wBAAmB;IAAnB,mBAAmB;IACnB,yBAAyB;IACzB,2BAA2B;IAC3B,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,4BAAuB;IAAvB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,wBAAmB;IAAnB,mBAAmB;IACnB,oBAAoB;IACpB,6BAA6B;AACjC;;AAEA;IACI,wBAAmB;IAAnB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX;2BACuB;IACvB,gBAAgB;IAChB,WAAW;IACX,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,wBAAmB;IAAnB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,8BAA8B;IAC9B,wBAAmB;IAAnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA,8EAA8E;AAC9E;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,UAAU;AACd","sourcesContent":[".main-container {\n    margin-top: 2vh;\n}\n\n.col {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    min-width: 20rem;\n    width: fit-content;\n    height: fit-content;\n    border: 2px solid #70d4e9;\n    background-color: #cdebf198;\n    border-radius: 1rem;\n    margin: .2rem .5rem;\n    padding: .5rem 0;\n}\n\n.view {\n    min-height: fit-content;\n}\n\n.title-row .col {\n    border: none;\n    height: fit-content;\n    margin-bottom: .5rem;\n    background-color: transparent;\n}\n\n.short {\n    height: fit-content;\n}\n\n.header {\n    text-align: center;\n    color: #000;\n    /* margin-top: .5rem;\n    margin-bottom: .3rem; */\n    padding: .5rem 0;\n    width: 100%;\n    border-bottom: 2px solid #70d4e9;\n}\n\n.btn-row {\n    margin: .5rem 0;\n    width: 100%;\n    height: 3.5rem;\n}\n\n.btn-row .col {\n    border: none;\n}\n\n.col-22 {\n    height: fit-content;\n    background: none;\n}\n\n.col-22 button {\n    width: 20%;\n    color: white;\n    font-size: 1.2rem;\n}\n\n.input-group {\n    height: 2.3rem;\n    margin-top: .7rem;\n}\n\n.manual-form {\n    display: flex;\n    justify-content: start;\n    flex-wrap: nowrap;\n    width: 100%;\n}\n\n.manual-btn {\n    width: 100%;\n}\n\n.form .form-control {\n    background-color: white;\n    color: black;\n    font-size: 1.1rem;\n    text-align: center;\n}\n\n.ml-module {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: space-between;\n    height: fit-content;\n}\n\n.ml-module .form-check {\n    margin: .5rem 0;\n    font-size: 1.2rem;\n}\n\n.form-check-label {\n    padding: 0 1rem;\n    font-size: 1.3rem;\n    color: #161616;\n}\n\n/* Schema Link flow: only the modal should be visible, on a plain white page */\nbody.schemalink-mode {\n    background-color: #ffffff;\n}\n\nbody.schemalink-mode .modal-backdrop.show {\n    background-color: #ffffff;\n    opacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
